import { useNavigationContainerRef } from 'expo-router/react-navigation';
import { useEffect } from 'react';
import { isWeb } from 'shared/constants/platform';
import { routingInstrumentation } from 'shared/utils/sentry/sentry';

export default function useSentryRoutingInstrumentation(
  navContainerRef: ReturnType<typeof useNavigationContainerRef>,
) {
  useEffect(() => {
    if (!isWeb && navContainerRef) {
      routingInstrumentation.registerNavigationContainer(navContainerRef);
    }
  }, [navContainerRef]);
}
